/**
 * 服务器时间校准工具。
 *
 * 接口响应头中的 `Date` 表示服务器当前时间，用它与本地时钟比对得到偏移量
 * （serverNow - localNow），后续以 `getServerNow()` 获取校准后的时间，避免本地
 * 时钟不准导致的倒计时偏差。注意 `Date` 头精度为秒级，叠加网络往返，允许 ±1s 误差。
 */

let offsetMs = 0

/**
 * 用接口响应头 `Date` 校准服务器与本地时钟的偏移量。
 * 头缺失或无法解析时静默忽略，保持上一次偏移量。
 */
export function syncServerTimeFromDateHeader(dateHeader?: string | null): void {
  if (!dateHeader) return
  const serverMs = new Date(dateHeader).getTime()
  if (Number.isNaN(serverMs)) return
  offsetMs = serverMs - Date.now()
}

/** 当前服务器时间（毫秒时间戳）。未同步前回退本地时间。 */
export function getServerNow(): number {
  return Date.now() + offsetMs
}

/** 当前服务器与本地时钟的偏移量（毫秒，serverNow - localNow）。 */
export function getServerTimeOffset(): number {
  return offsetMs
}
